// extracted by mini-css-extract-plugin
export default {"social-menu":"IOIw64u03XFRXD-YHQN+Jw==","icon":"nNL2HEq+fxSoWkbdCXDmFQ=="};